/* eslint-disable import/first */
import React from 'react';
import { RiStarFill } from '@react-icons/all-files/ri/RiStarFill';
import { BiStar } from '@react-icons/all-files/bi/BiStar';

import css from './index.module.scss';
const Star = (props) => {
  const changeGrade = (e) => {
    props.changeGradeIndex(e.target.value);
    changeSmile(e.target.value);
  };
  const changeSmile = (e) => {
    props.changeSmileIndex(e);
  };

  return (
    <label className={props.index === 0 ? css.firstStarLabel : css.starLabels}>
      <input
        type="radio"
        name="rating"
        id={props.grade}
        value={props.index}
        className={css.starsRadio}
        onClick={changeGrade}
      />
      {props?.type == 'active' ? (
        <RiStarFill className={css.starClass} fill="rgba(169, 189, 208, 0.3)" style={props.style} />
      ) : (
        <BiStar className={css.starClass} style={props.style} />

      )}
    </label>
  );
};

export default Star;
